import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { ACCOUNT_PATH } from '../../../../constants/paths/internal';
import { canUserManageConfigurations } from '../../../../lib/user';
import { StoreState } from '../../../../meta/types/store';
import { Claims } from '../../../../meta/types/user';
import { BaseRouteProps } from '../BaseRoute';

type PropsFromState = {
  authenticatedUser: Claims;
};

type Props = PropsFromState & BaseRouteProps;

const RootProtectedRoute = ({ authenticatedUser, component: Component, ...rest }: Props) => {
  const canManageConfigurations = canUserManageConfigurations(authenticatedUser);

  return (
    <Route
      {...rest}
      render={props => {
        if (!canManageConfigurations) {
          return <Redirect to={ACCOUNT_PATH} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    authenticatedUser: state.auth.authenticatedUser!,
  };
}

const enhance = connect(mapStateToProps);

export default enhance(RootProtectedRoute);
